// Translations for BlessBe app
export const translations = {
  en: {
    // Common
    appName: "BlessBe",
    tagline: "Spread kindness. Share blessings. Make today better.",
    loading: "Loading...",
    continue: "Continue",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    share: "Share",
    search: "Search",
    
    // Welcome
    welcomeBack: "Welcome Back",
    signIn: "Sign In",
    signUp: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Name",
    startJourney: "Start Your Journey",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    
    // Onboarding
    welcome: "Welcome!",
    whatToCallYou: "What should we call you?",
    yourName: "Your name",
    selectLanguage: "Select Language",
    chooseLanguage: "Choose your preferred language",
    faithPath: "Your Faith Path",
    christianFaith: "Christian Faith",
    christianDesc: "Scripture-based guidance with Biblical references",
    generalFaith: "General Faith",
    generalDesc: "Universal spiritual wisdom and guidance",
    selectGoals: "Select Your Goals",
    goalsDesc: "What would you like to focus on?",
    bibleTranslation: "Bible Translation",
    chooseVersion: "Choose your preferred version",
    preferences: "Preferences",
    howToGuide: "How should we guide you?",
    gentleTone: "Gentle & Warm",
    directTone: "Direct & Clear",
    sessionLength: "Session Length",
    shortSession: "Short (3-5 min)",
    mediumSession: "Medium (5-10 min)",
    longSession: "Long (10-15 min)",
    dailyReminder: "Daily Reminder",
    finishSetup: "Finish Setup",
    
    // Home
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
    today: "Today",
    library: "Library",
    journal: "Journal",
    readBible: "Read Bible",
    showKindness: "Show kindness to everyone today",
    dailyVerse: "Daily Verse",
    startSession: "Start Session",
    dayStreak: "day streak",
    readBibleBtn: "Read Bible",
    anyChapter: "Any chapter",
    pray: "Pray",
    startPraying: "Start praying",
    
    // Bible Reader
    theBible: "The Bible",
    oldTestament: "Old Testament",
    newTestament: "New Testament",
    selectChapter: "Select a chapter",
    backToBooks: "Back to Books",
    chapters: "Chapters",
    searchVerses: "Search verses (e.g., love, peace, faith)",
    noVersesFound: "No verses found",
    tryDifferent: "Try different keywords",
    clearSearch: "Clear Search",
    resultsFor: "results for",
    
    // Chat
    prayerCompanion: "Prayer Companion",
    hereForYou: "I'm here for you",
    typeMessage: "Type your message...",
    suggestedPrayers: "Suggested prayers",
    
    // Journal
    myJournal: "My Journal",
    howFeeling: "How are you feeling today?",
    writeThoughts: "Write your thoughts...",
    saveEntry: "Save Entry",
    getReflection: "Get AI Reflection",
    noEntries: "No entries yet",
    startWriting: "Start writing your thoughts",
    
    // Progress
    yourProgress: "Your Progress",
    currentStreak: "Current Streak",
    days: "days",
    thisWeek: "This Week",
    sessionsCompleted: "Sessions Completed",
    
    // Donate
    makeTodayBetter: "Make Today Better",
    giftHelps: "Your gift helps spread kindness and blessings around the world",
    donate: "Donate",
    thankYou: "Thank You!",
    generosity: "Your generosity helps spread kindness and blessings to people around the world.",
    backToHome: "Back to Home",
    
    // Settings
    settings: "Settings",
    profile: "Profile",
    appearance: "Appearance",
    notifications: "Notifications",
    signOut: "Sign Out",
    
    // Navigation
    home: "Home",
    word: "Word",
    give: "Give",
    impact: "Impact",
    
    // Goals
    peace: "Peace & Calm",
    gratitude: "Gratitude",
    discipline: "Discipline",
    relationships: "Relationships",
    forgiveness: "Forgiveness",
    purpose: "Purpose",
    sleep: "Better Sleep",
  },
  
  es: {
    appName: "BlessBe",
    tagline: "Difunde bondad. Comparte bendiciones. Mejora el día.",
    loading: "Cargando...",
    continue: "Continuar",
    back: "Atrás",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    share: "Compartir",
    search: "Buscar",
    welcomeBack: "Bienvenido",
    signIn: "Iniciar Sesión",
    signUp: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    startJourney: "Comienza Tu Viaje",
    welcome: "¡Bienvenido!",
    whatToCallYou: "¿Cómo te llamamos?",
    yourName: "Tu nombre",
    selectLanguage: "Seleccionar Idioma",
    chooseLanguage: "Elige tu idioma preferido",
    faithPath: "Tu Camino de Fe",
    christianFaith: "Fe Cristiana",
    christianDesc: "Guía basada en las Escrituras con referencias bíblicas",
    generalFaith: "Fe General",
    generalDesc: "Sabiduría espiritual universal",
    selectGoals: "Selecciona Tus Metas",
    goalsDesc: "¿En qué te gustaría enfocarte?",
    bibleTranslation: "Traducción de la Biblia",
    chooseVersion: "Elige tu versión preferida",
    preferences: "Preferencias",
    howToGuide: "¿Cómo debemos guiarte?",
    gentleTone: "Suave y Cálido",
    directTone: "Directo y Claro",
    sessionLength: "Duración de Sesión",
    shortSession: "Corta (3-5 min)",
    mediumSession: "Media (5-10 min)",
    longSession: "Larga (10-15 min)",
    dailyReminder: "Recordatorio Diario",
    finishSetup: "Finalizar Configuración",
    goodMorning: "Buenos días",
    goodAfternoon: "Buenas tardes",
    goodEvening: "Buenas noches",
    today: "Hoy",
    library: "Biblioteca",
    journal: "Diario",
    readBible: "Leer Biblia",
    showKindness: "Muestra bondad a todos hoy",
    dailyVerse: "Versículo del Día",
    startSession: "Iniciar Sesión",
    dayStreak: "días seguidos",
    readBibleBtn: "Leer Biblia",
    anyChapter: "Cualquier capítulo",
    pray: "Orar",
    startPraying: "Comenzar a orar",
    theBible: "La Biblia",
    oldTestament: "Antiguo Testamento",
    newTestament: "Nuevo Testamento",
    selectChapter: "Selecciona un capítulo",
    backToBooks: "Volver a Libros",
    chapters: "Capítulos",
    searchVerses: "Buscar versículos",
    noVersesFound: "No se encontraron versículos",
    tryDifferent: "Prueba diferentes palabras",
    clearSearch: "Limpiar Búsqueda",
    resultsFor: "resultados para",
    prayerCompanion: "Compañero de Oración",
    hereForYou: "Estoy aquí para ti",
    typeMessage: "Escribe tu mensaje...",
    myJournal: "Mi Diario",
    howFeeling: "¿Cómo te sientes hoy?",
    writeThoughts: "Escribe tus pensamientos...",
    saveEntry: "Guardar Entrada",
    getReflection: "Obtener Reflexión",
    noEntries: "Sin entradas aún",
    startWriting: "Comienza a escribir tus pensamientos",
    yourProgress: "Tu Progreso",
    currentStreak: "Racha Actual",
    days: "días",
    thisWeek: "Esta Semana",
    sessionsCompleted: "Sesiones Completadas",
    makeTodayBetter: "Mejora el Día de Hoy",
    giftHelps: "Tu regalo ayuda a difundir bondad y bendiciones",
    donate: "Donar",
    thankYou: "¡Gracias!",
    generosity: "Tu generosidad ayuda a difundir bondad en el mundo.",
    backToHome: "Volver al Inicio",
    settings: "Configuración",
    profile: "Perfil",
    signOut: "Cerrar Sesión",
    home: "Inicio",
    word: "Palabra",
    give: "Dar",
    impact: "Impacto",
    peace: "Paz y Calma",
    gratitude: "Gratitud",
    discipline: "Disciplina",
    relationships: "Relaciones",
    forgiveness: "Perdón",
    purpose: "Propósito",
    sleep: "Mejor Sueño",
  },
  
  fr: {
    appName: "BlessBe",
    tagline: "Répandez la bonté. Partagez les bénédictions.",
    loading: "Chargement...",
    continue: "Continuer",
    back: "Retour",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    share: "Partager",
    search: "Rechercher",
    welcomeBack: "Bienvenue",
    signIn: "Connexion",
    signUp: "Inscription",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom",
    startJourney: "Commencez Votre Voyage",
    welcome: "Bienvenue!",
    whatToCallYou: "Comment devons-nous vous appeler?",
    yourName: "Votre nom",
    selectLanguage: "Choisir la Langue",
    chooseLanguage: "Choisissez votre langue préférée",
    faithPath: "Votre Chemin de Foi",
    christianFaith: "Foi Chrétienne",
    christianDesc: "Guidance basée sur les Écritures",
    generalFaith: "Foi Générale",
    generalDesc: "Sagesse spirituelle universelle",
    selectGoals: "Sélectionnez Vos Objectifs",
    goalsDesc: "Sur quoi aimeriez-vous vous concentrer?",
    bibleTranslation: "Traduction de la Bible",
    chooseVersion: "Choisissez votre version préférée",
    preferences: "Préférences",
    finishSetup: "Terminer la Configuration",
    goodMorning: "Bonjour",
    goodAfternoon: "Bon après-midi",
    goodEvening: "Bonsoir",
    today: "Aujourd'hui",
    library: "Bibliothèque",
    journal: "Journal",
    readBible: "Lire la Bible",
    showKindness: "Montrez de la bonté à tous aujourd'hui",
    dailyVerse: "Verset du Jour",
    startSession: "Commencer la Session",
    dayStreak: "jours consécutifs",
    pray: "Prier",
    startPraying: "Commencer à prier",
    theBible: "La Bible",
    oldTestament: "Ancien Testament",
    newTestament: "Nouveau Testament",
    selectChapter: "Sélectionnez un chapitre",
    backToBooks: "Retour aux Livres",
    chapters: "Chapitres",
    prayerCompanion: "Compagnon de Prière",
    hereForYou: "Je suis là pour vous",
    typeMessage: "Tapez votre message...",
    myJournal: "Mon Journal",
    yourProgress: "Votre Progrès",
    currentStreak: "Série Actuelle",
    days: "jours",
    makeTodayBetter: "Améliorez Aujourd'hui",
    donate: "Faire un Don",
    thankYou: "Merci!",
    backToHome: "Retour à l'Accueil",
    settings: "Paramètres",
    signOut: "Déconnexion",
    home: "Accueil",
    word: "Parole",
    give: "Donner",
    impact: "Impact",
    peace: "Paix et Calme",
    gratitude: "Gratitude",
    discipline: "Discipline",
    relationships: "Relations",
    forgiveness: "Pardon",
    purpose: "But",
    sleep: "Meilleur Sommeil",
  },
  
  pt: {
    appName: "BlessBe",
    tagline: "Espalhe bondade. Compartilhe bênçãos.",
    loading: "Carregando...",
    continue: "Continuar",
    back: "Voltar",
    save: "Salvar",
    welcomeBack: "Bem-vindo",
    signIn: "Entrar",
    signUp: "Cadastrar",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    startJourney: "Comece Sua Jornada",
    welcome: "Bem-vindo!",
    whatToCallYou: "Como devemos te chamar?",
    selectLanguage: "Selecionar Idioma",
    chooseLanguage: "Escolha seu idioma preferido",
    faithPath: "Seu Caminho de Fé",
    christianFaith: "Fé Cristã",
    generalFaith: "Fé Geral",
    selectGoals: "Selecione Seus Objetivos",
    bibleTranslation: "Tradução da Bíblia",
    preferences: "Preferências",
    finishSetup: "Finalizar Configuração",
    goodMorning: "Bom dia",
    goodAfternoon: "Boa tarde",
    goodEvening: "Boa noite",
    today: "Hoje",
    library: "Biblioteca",
    journal: "Diário",
    readBible: "Ler Bíblia",
    dailyVerse: "Versículo do Dia",
    pray: "Orar",
    startPraying: "Começar a orar",
    theBible: "A Bíblia",
    prayerCompanion: "Companheiro de Oração",
    hereForYou: "Estou aqui para você",
    myJournal: "Meu Diário",
    yourProgress: "Seu Progresso",
    currentStreak: "Sequência Atual",
    days: "dias",
    donate: "Doar",
    thankYou: "Obrigado!",
    settings: "Configurações",
    signOut: "Sair",
    home: "Início",
    word: "Palavra",
    give: "Dar",
    impact: "Impacto",
    peace: "Paz e Calma",
    gratitude: "Gratidão",
    discipline: "Disciplina",
    relationships: "Relacionamentos",
    forgiveness: "Perdão",
    purpose: "Propósito",
    sleep: "Melhor Sono",
  },
  
  de: {
    appName: "BlessBe",
    tagline: "Verbreite Freundlichkeit. Teile Segen.",
    loading: "Laden...",
    continue: "Weiter",
    back: "Zurück",
    welcomeBack: "Willkommen",
    signIn: "Anmelden",
    signUp: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    startJourney: "Starte Deine Reise",
    welcome: "Willkommen!",
    whatToCallYou: "Wie sollen wir dich nennen?",
    selectLanguage: "Sprache Wählen",
    chooseLanguage: "Wähle deine bevorzugte Sprache",
    faithPath: "Dein Glaubensweg",
    christianFaith: "Christlicher Glaube",
    generalFaith: "Allgemeiner Glaube",
    selectGoals: "Wähle Deine Ziele",
    bibleTranslation: "Bibelübersetzung",
    preferences: "Einstellungen",
    finishSetup: "Einrichtung Abschließen",
    goodMorning: "Guten Morgen",
    goodAfternoon: "Guten Tag",
    goodEvening: "Guten Abend",
    today: "Heute",
    library: "Bibliothek",
    journal: "Tagebuch",
    readBible: "Bibel Lesen",
    dailyVerse: "Tagesvers",
    pray: "Beten",
    startPraying: "Anfangen zu beten",
    theBible: "Die Bibel",
    prayerCompanion: "Gebetsbegleiter",
    hereForYou: "Ich bin für dich da",
    myJournal: "Mein Tagebuch",
    yourProgress: "Dein Fortschritt",
    currentStreak: "Aktuelle Serie",
    days: "Tage",
    donate: "Spenden",
    thankYou: "Danke!",
    settings: "Einstellungen",
    signOut: "Abmelden",
    home: "Startseite",
    word: "Wort",
    give: "Geben",
    impact: "Wirkung",
    peace: "Frieden & Ruhe",
    gratitude: "Dankbarkeit",
    discipline: "Disziplin",
    relationships: "Beziehungen",
    forgiveness: "Vergebung",
    purpose: "Sinn",
    sleep: "Besserer Schlaf",
  },
  
  zh: {
    appName: "BlessBe",
    tagline: "传播善意。分享祝福。让今天更美好。",
    loading: "加载中...",
    continue: "继续",
    back: "返回",
    save: "保存",
    welcomeBack: "欢迎回来",
    signIn: "登录",
    signUp: "注册",
    email: "电子邮件",
    password: "密码",
    name: "姓名",
    startJourney: "开始你的旅程",
    welcome: "欢迎！",
    whatToCallYou: "我们该怎么称呼你？",
    selectLanguage: "选择语言",
    chooseLanguage: "选择您的首选语言",
    faithPath: "你的信仰之路",
    christianFaith: "基督教信仰",
    generalFaith: "普遍信仰",
    selectGoals: "选择你的目标",
    bibleTranslation: "圣经翻译",
    preferences: "偏好设置",
    finishSetup: "完成设置",
    goodMorning: "早上好",
    goodAfternoon: "下午好",
    goodEvening: "晚上好",
    today: "今天",
    library: "图书馆",
    journal: "日记",
    readBible: "阅读圣经",
    dailyVerse: "每日经文",
    pray: "祈祷",
    startPraying: "开始祈祷",
    theBible: "圣经",
    prayerCompanion: "祈祷伙伴",
    hereForYou: "我在这里陪伴你",
    myJournal: "我的日记",
    yourProgress: "你的进度",
    currentStreak: "当前连续",
    days: "天",
    donate: "捐赠",
    thankYou: "谢谢！",
    settings: "设置",
    signOut: "退出",
    home: "首页",
    word: "话语",
    give: "奉献",
    impact: "影响",
    peace: "平静安宁",
    gratitude: "感恩",
    discipline: "自律",
    relationships: "人际关系",
    forgiveness: "宽恕",
    purpose: "目标",
    sleep: "更好的睡眠",
  },
  
  ko: {
    appName: "BlessBe",
    tagline: "친절을 나누세요. 축복을 공유하세요.",
    loading: "로딩 중...",
    continue: "계속",
    back: "뒤로",
    welcomeBack: "환영합니다",
    signIn: "로그인",
    signUp: "회원가입",
    email: "이메일",
    password: "비밀번호",
    name: "이름",
    startJourney: "여정을 시작하세요",
    welcome: "환영합니다!",
    whatToCallYou: "어떻게 불러드릴까요?",
    selectLanguage: "언어 선택",
    chooseLanguage: "선호하는 언어를 선택하세요",
    faithPath: "믿음의 길",
    christianFaith: "기독교 신앙",
    generalFaith: "일반 신앙",
    selectGoals: "목표 선택",
    bibleTranslation: "성경 번역",
    preferences: "환경설정",
    finishSetup: "설정 완료",
    goodMorning: "좋은 아침",
    goodAfternoon: "좋은 오후",
    goodEvening: "좋은 저녁",
    today: "오늘",
    library: "도서관",
    journal: "일기",
    readBible: "성경 읽기",
    dailyVerse: "오늘의 말씀",
    pray: "기도",
    startPraying: "기도 시작",
    theBible: "성경",
    prayerCompanion: "기도 동반자",
    hereForYou: "당신과 함께합니다",
    myJournal: "나의 일기",
    yourProgress: "나의 진행",
    currentStreak: "현재 연속",
    days: "일",
    donate: "기부",
    thankYou: "감사합니다!",
    settings: "설정",
    signOut: "로그아웃",
    home: "홈",
    word: "말씀",
    give: "헌금",
    impact: "영향",
    peace: "평화와 평온",
    gratitude: "감사",
    discipline: "절제",
    relationships: "관계",
    forgiveness: "용서",
    purpose: "목적",
    sleep: "더 나은 수면",
  },
  
  ar: {
    appName: "BlessBe",
    tagline: "انشر اللطف. شارك البركات.",
    loading: "جاري التحميل...",
    continue: "متابعة",
    back: "رجوع",
    welcomeBack: "مرحباً بعودتك",
    signIn: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    startJourney: "ابدأ رحلتك",
    welcome: "مرحباً!",
    whatToCallYou: "ماذا نناديك؟",
    selectLanguage: "اختر اللغة",
    chooseLanguage: "اختر لغتك المفضلة",
    faithPath: "مسار إيمانك",
    christianFaith: "الإيمان المسيحي",
    generalFaith: "إيمان عام",
    selectGoals: "اختر أهدافك",
    bibleTranslation: "ترجمة الكتاب المقدس",
    preferences: "التفضيلات",
    finishSetup: "إنهاء الإعداد",
    goodMorning: "صباح الخير",
    goodAfternoon: "مساء الخير",
    goodEvening: "مساء الخير",
    today: "اليوم",
    library: "المكتبة",
    journal: "اليومية",
    readBible: "قراءة الكتاب المقدس",
    dailyVerse: "آية اليوم",
    pray: "صلاة",
    startPraying: "ابدأ الصلاة",
    theBible: "الكتاب المقدس",
    prayerCompanion: "رفيق الصلاة",
    hereForYou: "أنا هنا من أجلك",
    myJournal: "يومياتي",
    yourProgress: "تقدمك",
    currentStreak: "السلسلة الحالية",
    days: "أيام",
    donate: "تبرع",
    thankYou: "شكراً!",
    settings: "الإعدادات",
    signOut: "تسجيل الخروج",
    home: "الرئيسية",
    word: "الكلمة",
    give: "عطاء",
    impact: "تأثير",
    peace: "السلام والهدوء",
    gratitude: "الامتنان",
    discipline: "الانضباط",
    relationships: "العلاقات",
    forgiveness: "المغفرة",
    purpose: "الهدف",
    sleep: "نوم أفضل",
  },
  
  hi: {
    appName: "BlessBe",
    tagline: "दया फैलाएं। आशीर्वाद बांटें।",
    loading: "लोड हो रहा है...",
    continue: "जारी रखें",
    back: "वापस",
    welcomeBack: "वापस स्वागत है",
    signIn: "साइन इन",
    signUp: "साइन अप",
    email: "ईमेल",
    password: "पासवर्ड",
    name: "नाम",
    startJourney: "अपनी यात्रा शुरू करें",
    welcome: "स्वागत है!",
    whatToCallYou: "हम आपको क्या बुलाएं?",
    selectLanguage: "भाषा चुनें",
    chooseLanguage: "अपनी पसंदीदा भाषा चुनें",
    faithPath: "आपका विश्वास मार्ग",
    christianFaith: "ईसाई विश्वास",
    generalFaith: "सामान्य विश्वास",
    selectGoals: "अपने लक्ष्य चुनें",
    bibleTranslation: "बाइबिल अनुवाद",
    preferences: "प्राथमिकताएं",
    finishSetup: "सेटअप समाप्त करें",
    goodMorning: "सुप्रभात",
    goodAfternoon: "शुभ दोपहर",
    goodEvening: "शुभ संध्या",
    today: "आज",
    library: "पुस्तकालय",
    journal: "डायरी",
    readBible: "बाइबिल पढ़ें",
    dailyVerse: "दैनिक वचन",
    pray: "प्रार्थना",
    startPraying: "प्रार्थना शुरू करें",
    theBible: "बाइबिल",
    prayerCompanion: "प्रार्थना साथी",
    hereForYou: "मैं आपके लिए यहां हूं",
    myJournal: "मेरी डायरी",
    yourProgress: "आपकी प्रगति",
    currentStreak: "वर्तमान श्रृंखला",
    days: "दिन",
    donate: "दान करें",
    thankYou: "धन्यवाद!",
    settings: "सेटिंग्स",
    signOut: "साइन आउट",
    home: "होम",
    word: "वचन",
    give: "देना",
    impact: "प्रभाव",
    peace: "शांति और सुकून",
    gratitude: "कृतज्ञता",
    discipline: "अनुशासन",
    relationships: "रिश्ते",
    forgiveness: "क्षमा",
    purpose: "उद्देश्य",
    sleep: "बेहतर नींद",
  },
  
  sw: {
    appName: "BlessBe",
    tagline: "Eneza huruma. Shiriki baraka.",
    loading: "Inapakia...",
    continue: "Endelea",
    back: "Rudi",
    welcomeBack: "Karibu tena",
    signIn: "Ingia",
    signUp: "Jisajili",
    email: "Barua pepe",
    password: "Nenosiri",
    name: "Jina",
    startJourney: "Anza Safari Yako",
    welcome: "Karibu!",
    whatToCallYou: "Tukuite nini?",
    selectLanguage: "Chagua Lugha",
    chooseLanguage: "Chagua lugha unayopendelea",
    faithPath: "Njia Yako ya Imani",
    christianFaith: "Imani ya Kikristo",
    generalFaith: "Imani ya Jumla",
    selectGoals: "Chagua Malengo Yako",
    bibleTranslation: "Tafsiri ya Biblia",
    preferences: "Mapendeleo",
    finishSetup: "Maliza Usanidi",
    goodMorning: "Habari ya asubuhi",
    goodAfternoon: "Habari ya mchana",
    goodEvening: "Habari ya jioni",
    today: "Leo",
    library: "Maktaba",
    journal: "Jarida",
    readBible: "Soma Biblia",
    dailyVerse: "Aya ya Leo",
    pray: "Omba",
    startPraying: "Anza kuomba",
    theBible: "Biblia",
    prayerCompanion: "Mwenza wa Maombi",
    hereForYou: "Niko hapa kwa ajili yako",
    myJournal: "Jarida Langu",
    yourProgress: "Maendeleo Yako",
    currentStreak: "Mfululizo wa Sasa",
    days: "siku",
    donate: "Changia",
    thankYou: "Asante!",
    settings: "Mipangilio",
    signOut: "Ondoka",
    home: "Nyumbani",
    word: "Neno",
    give: "Toa",
    impact: "Athari",
    peace: "Amani na Utulivu",
    gratitude: "Shukrani",
    discipline: "Nidhamu",
    relationships: "Mahusiano",
    forgiveness: "Msamaha",
    purpose: "Kusudi",
    sleep: "Usingizi Bora",
  },
};

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'sw', name: 'Kiswahili', flag: '🇰🇪' },
];

export const getTranslation = (lang, key) => {
  const langTranslations = translations[lang] || translations['en'];
  return langTranslations[key] || translations['en'][key] || key;
};
